import { useSelector } from 'react-redux';
import { getCurrentUser } from '../../publicSession/selectors';
/** returns the currently logged in user (if any) */
export function useCurrentUser() {
    return useSelector(getCurrentUser);
}
//# sourceMappingURL=useCurrentUser.js.map